import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import { SOURCE_LABELS } from '@/constants/feature-labels';
import type { AccountSource } from '@/types';

const STYLE: Record<AccountSource, string> = {
  both: 'bg-teal-50 text-teal-700 ring-teal-600/20',
  mongo: 'bg-amber-50 text-amber-700 ring-amber-600/20',
  // Main-system-only is the common case — keep it quiet so it isn't noise.
  postgres: 'text-muted-foreground ring-transparent'
};

export function SourceBadge({ source }: { source: AccountSource }) {
  const meta = SOURCE_LABELS[source] ?? SOURCE_LABELS.postgres;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className={cn(
            'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset',
            STYLE[source]
          )}
        >
          {meta.label}
        </span>
      </TooltipTrigger>
      <TooltipContent>{meta.tooltip}</TooltipContent>
    </Tooltip>
  );
}
